import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { GOAL_STATUSES } from '../../../constants/constants';
import './SalesGoals.scss';
import GraphDonut from '../../Common/GraphDonut/GraphDonut';
import Icon from '../../Common/Icon';
import EditGoalGroupDrawer from './EditGoalGroupDrawer';

export class SalesGoals extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: true,
            goalGroups: [],
            isEditDrawerOpen: false,
            editGoalGroup: null
        };
    }

    componentDidMount = async () => {
        await this.loadGoals();
    }

    componentDidUpdate(prevProps) {
        // reload the goals when the user changes locations
        // they could be searching for a location so make sure there is a value
        if (this.props.locationKey && this.props.locationKey !== prevProps.locationKey) {
            this.setState({ goalGroups: [], isLoading: true }, this.loadGoals);
        }
    }

    loadGoals = async () => {
        // the user could be searching for a location and not have one selected yet
        if (this.props.locationKey === "") { return; }
        try {
            const response = await this.props.locationDashboardActions.loadLocationGoals(this.props.locationKey);
            if (response.type === types.LOAD_LOCATION_GOALS_SUCCESS) {

                this.setState({
                    goalGroups: response.payload.goalGroups
                })

            } else if (response.type === types.LOAD_LOCATION_GOALS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }

    }

    buildGraphData = (goal) => {

        // if the goal is met, then only display the total in the donut as exceeding
        // there is also some logic below to render some other things differently
        if (goal.isGoalMet) {
            return [
                {
                    id: GOAL_STATUSES.Exceeding.title,
                    label: GOAL_STATUSES.Exceeding.title,
                    value: goal.totalValue || 0,
                    color: GOAL_STATUSES.Exceeding.color
                },
            ];
        } else {
            return [
                {
                    id: goal.darkGreenName,
                    label: goal.darkGreenName,
                    value: goal.darkGreenValue || 0,
                    color: GOAL_STATUSES.DarkGreen.color
                },
                {
                    id: goal.mediumGreenName,
                    label: goal.mediumGreenName,
                    value: goal.mediumGreenValue || 0,
                    color: GOAL_STATUSES.MediumGreen.color
                },
                {
                    id: goal.lightGreenName,
                    label: goal.lightGreenName,
                    value: goal.lightGreenValue || 0,
                    color: GOAL_STATUSES.LightGreen.color
                },
                {
                    id: GOAL_STATUSES.Remaining.title,
                    label: GOAL_STATUSES.Remaining.title,
                    value: goal.remainingValue || 0,
                    color: GOAL_STATUSES.Remaining.color
                }
            ];
        }
    }

    getPercentage = (num, total) => {
        if (num && num > 0 && total && total > 0) {
            return Math.round(num / total * 100) + "%";
        } else {
            return "";
        }
    }

    onEditGoalGroupClick = (goalGroup) => {
        this.setState({ isEditDrawerOpen: true, editGoalGroup: goalGroup });
    }

    onEditComplete = () => {
        this.setState({ isEditDrawerOpen: false }, this.loadGoals);
    }

    onEditCancel = () => {
        this.setState({ isEditDrawerOpen: false });
    }

    render() {
        return (
            <div className="sales-goals-widget">
                {this.state.isEditDrawerOpen &&
                    <EditGoalGroupDrawer
                        locationDashboardActions={this.props.locationDashboardActions}
                        onComplete={this.onEditComplete}
                        onCancel={this.onEditCancel}
                        locationKey={this.props.locationKey}
                        goalGroup={this.state.editGoalGroup} />
                }
                <div className="row no-gutters">
                    <div className="col-12">
                        <div className="dashboard-widget-title">Sales Goals</div>
                    </div>
                </div>
                {this.state.goalGroups && this.state.goalGroups.length > 0 &&
                    <Fragment>
                        {this.state.goalGroups.map((goalGroup) => (
                            <div className="goal-group mb-4" key={goalGroup.name}>
                                {/* Group Name Section */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="group-name mb-0">{goalGroup.name}</h5>
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => this.onEditGoalGroupClick(goalGroup)}
                                        title="Edit Group"
                                    >
                                        <Icon name="pencil-alt" />
                                    </button>
                                </div>

                                {/* Goals Section */}
                                <div className="row g-4">
                                    {goalGroup.goals.map((goal) => (
                                        <div className="col-sm-12 col-md-6" key={goal.goalId}>
                                            <div className="card">
                                                {/* Goal Title */}
                                                <div className="card-header text-center fw-bold">{goal.name}</div>

                                                {/* Card Body */}
                                                <div className="card-body">
                                                    <div className="row g-3">
                                                        {/* Donut Graph */}
                                                        <div className="col-lg-6 d-flex justify-content-center align-items-center">
                                                            <GraphDonut
                                                                title="Goal"
                                                                data={this.buildGraphData(goal)}
                                                                total={goal.totalValue || 0}
                                                            />
                                                        </div>

                                                        {/* Goal Details */}
                                                        <div className="col-lg-6">
                                                            <ul className="list-group">
                                                                {/* Goal Total */}
                                                                <li className="list-group-item d-flex justify-content-between">
                                                                    <span className="goal-total fw-bold">Goal Total</span>
                                                                    <span>{goal.totalValue}</span>
                                                                </li>

                                                                {/* Dark Green */}
                                                                <li className="list-group-item d-flex justify-content-between">
                                                                    <div className="d-flex align-items-center">
                                                                        <div
                                                                            style={{
                                                                                color: GOAL_STATUSES.DarkGreen.color,
                                                                            }}
                                                                            className="me-2"
                                                                        >
                                                                            <Icon name="circle" />
                                                                        </div>
                                                                        {goal.darkGreenName}
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <div className="percent small">
                                                                            {this.getPercentage(goal.darkGreenValue, goal.totalValue)}
                                                                        </div>
                                                                        {goal.darkGreenValue}
                                                                    </div>
                                                                </li>

                                                                {/* Medium Green */}
                                                                <li className="list-group-item d-flex justify-content-between">
                                                                    <div className="d-flex align-items-center">
                                                                        <div
                                                                            style={{
                                                                                color: GOAL_STATUSES.MediumGreen.color,
                                                                            }}
                                                                            className="me-2"
                                                                        >
                                                                            <Icon name="circle" />
                                                                        </div>
                                                                        {goal.mediumGreenName}
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <div className="percent small">
                                                                            {this.getPercentage(goal.mediumGreenValue, goal.totalValue)}
                                                                        </div>
                                                                        {goal.mediumGreenValue}
                                                                    </div>
                                                                </li>

                                                                {/* Light Green */}
                                                                <li className="list-group-item d-flex justify-content-between">
                                                                    <div className="d-flex align-items-center">
                                                                        <div
                                                                            style={{
                                                                                color: GOAL_STATUSES.LightGreen.color,
                                                                            }}
                                                                            className="me-2"
                                                                        >
                                                                            <Icon name="circle" />
                                                                        </div>
                                                                        {goal.lightGreenName}
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <div className="percent small">
                                                                            {this.getPercentage(goal.lightGreenValue, goal.totalValue)}
                                                                        </div>
                                                                        {goal.lightGreenValue}
                                                                    </div>
                                                                </li>

                                                                {/* Exceeding or Remaining */}
                                                                <li className="list-group-item d-flex justify-content-between">
                                                                    <div className="d-flex align-items-center">
                                                                        <div
                                                                            style={{
                                                                                color: goal.isGoalMet
                                                                                    ? GOAL_STATUSES.Exceeding.color
                                                                                    : GOAL_STATUSES.Remaining.color,
                                                                            }}
                                                                            className="me-2"
                                                                        >
                                                                            <Icon name="circle" />
                                                                        </div>
                                                                        {goal.isGoalMet
                                                                            ? GOAL_STATUSES.Exceeding.title
                                                                            : GOAL_STATUSES.Remaining.title}
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <div className="percent small">
                                                                            {this.getPercentage(goal.remainingValue, goal.totalValue)}
                                                                        </div>
                                                                        {goal.remainingValue}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </Fragment>

                }
            </div>
        )
    }


}
SalesGoals.propTypes = {
    locationKey: PropTypes.string, // not required - user could be searching for a location
    locationDashboardActions: PropTypes.object.isRequired,
};

export default SalesGoals;